export default __webpack_public_path__ + "static/media/IMG_9100(2).d6de585b.jpg";